import Yup from 'utils/yup'

export const defaultValues = {
  maintenanceActionId: null,
}

export const validationSchema = Yup.object().shape({
  maintenanceActionId: Yup.string().nullable().required(),
})
